import req from "../http";

// 職缺管理
const jobManagement = {
  // 取得 履歷數量(分頁)
  getResumeViewPaging(params, manpowerDemandNo) {
    let newParams = {
      ...params,
      ManpowerDemandNo: manpowerDemandNo,
    };
    return req(
      "post",
      `/Recruitment/JobManagementByResumeView/V2/paging`,
      newParams
    );
  },

  // 取得 待面談(分頁)
  getInInterviewingPaging(params, manpowerDemandNo) {
    return req(
      "get",
      `/Recruitment/JobManagementByInInterview/V2/paging/${manpowerDemandNo}`,
      params
    );
  },

  // 取得 已面談(分頁)
  getInterviewedPaging(params, manpowerDemandNo) {
    return req(
      "get",
      `/Recruitment/JobManagementByInterviewed/V2/paging/${manpowerDemandNo}`,
      params
    );
  },

  // 取得 面談結果(分頁)
  getInterviewResultPaging(params, manpowerDemandNo) {
    return req(
      "get",
      `/Recruitment/JobManagementByInterviewResult/paging/${manpowerDemandNo}`,
      params
    );
  },

  // 取得 面談未到(分頁)
  getDeclineInterviewPaging(params, manpowerDemandNo) {
    return req(
      "get",
      `/Recruitment/JobManagementByInterviewNotArrived/paging/${manpowerDemandNo}`,
      params
    );
  },

  // 取得 任用結果(分頁)
  getAppointmentResultPaging(params, manpowerDemandNo) {
    return req(
      "get",
      `/Recruitment/JobManagementByAppointmentResult/paging/${manpowerDemandNo}`,
      params
    );
  },

  // 履歷標記過期
  expireResume(params) {
    return req("post", "/Recruitment/JobManagement/ExpireResume", params);
  },

  // 履歷全部標記過期
  expireAllResume(params) {
    return req(
      "post",
      "/Recruitment/JobManagement/ExpireResume/ChooseAll",
      params
    );
  },

  // 移除過期標記
  recoverResume(params) {
    return req("post", "/Recruitment/JobManagement/RecoverResume", params);
  },

  // 全部履歷移除過期標記
  recoverAllResume(params) {
    return req(
      "post",
      "/Recruitment/JobManagement/RecoverResume/ChooseAll",
      params
    );
  },

  // 移除履歷
  removeResume(params) {
    return req("post", "/Recruitment/JobManagement/RemoveResume", params);
  },

  // 全選移除履歷
  removeAllResume(params) {
    return req("post", "/Recruitment/JobManagement/RemoveResume/ChooseAll", params);
  },

  // 面談未到(填寫原因)
  interviewNotArrived(params) {
    return req("post", "/Recruitment/InterviewNotArrived", params);
  },

  // 取得 應聘者履歷狀況
  getResumeSummary(matchId) {
    return req("get", `/Recruitment/JobManagement/MatchSummary/${matchId}`);
  },

  // 更新 應聘者履歷狀況
  putResumeSummary(params) {
    return req("put", "/Recruitment/JobManagement/MatchSummary", params);
  },

  // 批次更新 應聘者所屬廠別
  changeFactoryTypes(params) {
    return req("put", "/Recruitment/JobManagement/FactoryTypes", params);
  },

  // 全選更新 應聘者所屬廠別
  changeAllFactoryTypes(params) {
    return req("post", "/Recruitment/JobManagement/FactoryTypes/ChooseAll", params);
  },


  // 取得職缺各種狀態數量
  getJobManagementCount(manpowerDemandNo) {
    return req("get", `/Recruitment/JobManagementCount/${manpowerDemandNo}`);
  },
};

export default jobManagement;
